import { SagaGenerator, actionChannel, put, select, take } from 'typed-redux-saga';
import { Channel } from 'redux-saga';
import { WishlistSettings } from '@spa/lib/store/settings/WishlistSettings';
import generateActionId from '@spa/lib/generateActionId';
import { getMyWishlistsRequested } from '@spa/lib/store/wishlists/wishlistsSlice';
import { isAnyOf } from '@reduxjs/toolkit';
import selectWishlistSettings from '@spa/lib/store/settings/selectors/selectWishlistSettings';
import { setAuthState } from '@spa/lib/store/auth/authSlice';
import shouldLoadWishlists from '@spa/lib/shouldLoadWishlists';

function* watchAuthChangesSaga(): SagaGenerator<void> {
  const chan: Channel<ReturnType<typeof setAuthState>> = yield* actionChannel(
    isAnyOf(setAuthState)
  );

  let lastUserId: string | null = null;
  let lastToken: string | null = null;

  while (true) {
    const action: ReturnType<typeof setAuthState> = yield* take(chan);
    const { accessToken, authenticatedUserId } = action.payload;

    const wishlistSettings: WishlistSettings = yield* select(selectWishlistSettings);

    const becameLoggedIn = !!accessToken && !!authenticatedUserId;
    const userChanged = authenticatedUserId !== lastUserId;
    const tokenChanged = accessToken !== lastToken;

    if (shouldLoadWishlists(wishlistSettings) && becameLoggedIn && (userChanged || tokenChanged)) {
      yield* put(
        getMyWishlistsRequested({
          actionId: generateActionId()
        })
      );
    }

    lastUserId = authenticatedUserId;
    lastToken = accessToken;
  }
}

export default watchAuthChangesSaga;
